import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cfe9b00f-e0c3-43fb-beb3-07e882f6793d",
  "use": "icon-cfe9b00f-e0c3-43fb-beb3-07e882f6793d-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cfe9b00f-e0c3-43fb-beb3-07e882f6793d\"><path d=\"M164.571429 198.802286l51.2-51.2L968.265143 899.657143l-51.2 51.2z\" fill=\"#5E6E7D\" p-id=\"4728\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol